import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {
  Box, Dialog, DialogContent, DialogTitle,
  TextField, MenuItem, Button,
} from '@material-ui/core';

const useStyle = makeStyles(() => ({
  titleArea: {
    padding: 0,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: '#242424',
    padding: '10px',
  },
  titleStyle: {
    marginLeft: '5px',
    color: 'rgba(255, 255, 255, 1)',
  },
  inputInfoContainer: {
    padding: '10px',
  },
  inputTitleInfo: {
    fontSize: '15px',
    fontWeight: 600,
    color: '#fff',
  },
}));

export default function ModalCustomEndpointManager({
  data, params, fields, variables, editTypeInput, editParamInput, open, onClose,
}) {
  const classes = useStyle();
  const [inputs, setInputs] = useState([]);
  const [paramData, setParamData] = useState([]);
  const typesOfFields = [
    {value: 'variable', label: 'Variables'},
    {value: 'dbfield', label: 'Campo Base de Datos'},
    {value: 'useparams', label: 'Parametros'},
    {value: 'static', label: 'Estatico'},
  ];
  useEffect(() => {
    setInputs(data);
    setParamData(params);
  });

  function checkTypeOf(paramValue, compareTo) {
    if (paramValue === 'string' && (compareTo === 'string' || compareTo === 'database' || compareTo === 'relation')) {
      return true;
    }
    if (paramValue === compareTo) {
      return true;
    }
    return false;
  }
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle className={classes.titleArea}>
        <Box className={classes.titleContainer}>
          <Box className={classes.titleStyle}>
            Parametros de Personalizados
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent style={{background: '#242424', color: '#fff'}}>
        <Box
          component="div"
          style={{
            margin: '15px', padding: '5px', height: '400px', overflowY: 'scroll',
          }}
        >
          {
              inputs.map((index) => (
                <Box component="div" className={classes.inputInfoContainer} key={index}>
                  <Box component="div" className={classes.inputTitleInfo}>
                    {index.paramendpoint.label}
                  </Box>
                  <div className="my-4">
                    <TextField
                      onChange={(e) => editTypeInput(index, e.target.value)}
                      value={index.state}
                      select
                      fullWidth
                      name="type"
                      type="text"
                      label="Usar Parametro con:"
                      variant="standard"
                      style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                    >
                      {
                          typesOfFields.map(({label, value}) => (
                            <MenuItem value={value} key={value}>
                              {label}
                            </MenuItem>
                          ))
                        }
                    </TextField>
                  </div>
                  {index.state === 'useparams' && (
                    <div>
                      <TextField
                        select
                        fullWidth
                        name="type"
                        onChange={(e) => editParamInput(index, e.target.value)}
                        value={index?.param}
                        type="text"
                        label="Parametros:"
                        variant="standard"
                        style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                      >
                        {
                          paramData?.map(({value, name}) => (
                            <MenuItem value={value} key={value}>
                              {name}
                            </MenuItem>
                          ))
                        }
                      </TextField>
                    </div>
                  )}
                  {index.state === 'variable' && (
                    <div>
                      <TextField
                        select
                        fullWidth
                        name="type"
                        onChange={(e) => editParamInput(index, e.target.value)}
                        value={index?.param}
                        type="text"
                        label="Parametros:"
                        variant="standard"
                        style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                      >
                        {
                          variables?.filter(
                            (fieldData) => (checkTypeOf(index.paramendpoint.type, fieldData.type)),
                          )?.map(({value, name}) => (
                            <MenuItem value={value} key={value}>
                              {name}
                            </MenuItem>
                          ))
                        }
                      </TextField>
                    </div>
                  )}
                  {index.state === 'dbfield' && (
                    <div>
                      <TextField
                        select
                        fullWidth
                        name="type"
                        onChange={(e) => editParamInput(index, e.target.value)}
                        value={index?.param}
                        type="text"
                        label="Parametros:"
                        variant="standard"
                        style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                      >
                        {
                          fields?.filter(
                            (fieldData) => (checkTypeOf(index.paramendpoint.type, fieldData.type)),
                          )?.map(({value, name}) => (
                            <MenuItem value={value} key={value}>
                              {name}
                            </MenuItem>
                          ))
                        }
                      </TextField>
                    </div>
                  )}
                  {index.state === 'static' && (index?.paramendpoint?.stringDefaultValues.length > 0) && (
                    <div>
                      <TextField
                        select
                        fullWidth
                        name="type"
                        onChange={(e) => editParamInput(index, e.target.value)}
                        value={index?.param}
                        type="text"
                        label="Valor por defecto:"
                        variant="standard"
                        style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                      >
                        {
                          index?.paramendpoint?.stringDefaultValues?.map(({label, slug}) => (
                            <MenuItem value={slug} key={slug}>
                              {label}
                            </MenuItem>
                          ))
                        }
                      </TextField>
                    </div>
                  )}
                  {index.state === 'static' && (!index?.paramendpoint?.stringDefaultValues || index?.paramendpoint?.stringDefaultValues.length === 0) && (
                    <div>
                      <TextField
                        fullWidth
                        name="type"
                        onChange={(e) => editParamInput(index, e.target.value)}
                        value={index?.param}
                        type="text"
                        label="Valor estatico:"
                        variant="standard"
                        style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                      />
                    </div>
                  )}
                </Box>
              ))
            }
        </Box>
        <Box className={classes.buttonAreaContainer}>
          <Button
            variant="contained"
            color="secondary"
            onClick={onClose}
            className={classes.buttonStyle}
          >
            Cerrar
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
